<ng-container *ngIf="quoteDetailsForSeller$ | async as quoteDetails">
  <div class="cx-seller-edit-body">
    <form (ngSubmit)="onApply(quoteDetails.code)" [formGroup]="form">
      <label>
        <span
          [attr.aria-label]="
            'quote.summary.sellerEdit.a11y.expiryDate' | cxTranslate
          "
          class="label-content bold"
        >{{ 'quote.summary.sellerEdit.expiryDate' | cxTranslate }}</span
        >
        <cx-date-picker
          [control]="$any(form.get('validityDate'))"
          [required]="true"
          (update)="onSetDate(quoteDetails.code)"
        ></cx-date-picker>
      </label>
    </form>
  </div>
</ng-container>
